<div class="title">{{ title | translate }}</div>
<div class="form-wrapper-semi-auto">
  <div class="form-label">{{ 'msg.user.rawmaterial.import.file-to-import' | translate}} *</div>
  <div class="form-input-div">
    <input pInputText type="text" class="form-input" [ngClass]="{ 'error-input': !isValidFile && showError }"
      (click)="fileInput.click()" readonly [ngModel]="fileName" />

    <input pInput type="file" (change)="onFileSelection($event)" #fileInput hidden />
  </div>
  <small class="error-msg">{{ fileErrorMessage }}</small>
</div>
<div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
  <button pButton class="neq-primeng-button-text" (click)="startImport()" [disabled]="!isValidFile"
    label="{{'label.common.import' | translate}}"></button>
  <button pButton class="neq-primeng-button-text" (click)="close()"
    label="{{'msg.common.validation.cancel' | translate}}"></button>
</div>
